import { singleton, inject } from "tsyringe";

// shared
import type { HttpAdapter } from "@/shared/libs/http/interface";

// domain
import { LocationRepository } from "@/entities/location/domain/repository";
import type { GetLocationsResponseDto } from "@/entities/location/domain/dtos";

@singleton()
export default class LocationRepositoryImpl implements LocationRepository {
    constructor(@inject("HttpAdapter") private readonly httpAdaptor: HttpAdapter) {}

    public getLocations = async () => {
        const response = await this.httpAdaptor.get<GetLocationsResponseDto>(`/v1/locations`);

        return response;
    };
}
